import script from "./ProductImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductImages.vue?vue&type=script&setup=true&lang=ts"

import "./ProductImages.vue?vue&type=style&index=0&id=2f2fcadc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2fcadc"]])

export default __exports__